import script from "./TabFieldInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFieldInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__